import { CreateMembershipDurationInput, CreateMembershipDurationError } from "../../../store/actionType";

export const validatePackageForm = (
  formData: CreateMembershipDurationInput
): { isValid: boolean; errors: CreateMembershipDurationError } => {
  const errors: CreateMembershipDurationError = {};

  if (!formData.duration_type.trim()) {
    errors.duration_type = "Duration Type is required";
  }
  if (!formData.description.trim()) {
    errors.description = "Package Description is required";
  }
  if (!formData.number_of_days) {
    errors.number_of_days = "Number of days is required";
  }
  if (!formData.price) {
    errors.price = "Price is required";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
